export type RenderLogDoc = 'SOURCE' | 'TARGET';

/** The UI calls the target document "New", so the panel's labels have to match the rest of the app. */
export function formatRenderLogDocLabel(doc: RenderLogDoc): 'Source' | 'New' {
  return doc === 'SOURCE' ? 'Source' : 'New';
}

export interface RenderLogEntry {
  id: number;
  ts: number;
  doc: RenderLogDoc;
  event: string;
  detail: string;
}

/** Event names shown in the panel, including the labels used for the wrapped viewer methods. */
export const RENDER_LOG_EVENT_NAMES = [
  'beginRendering',
  'finishedRendering',
  'pageComplete',
  'pagesUpdated',
  'visiblePagesChanged',
  'pageNumberUpdated',
  'zoomUpdated',
  'displayPageLocation',
  'refreshAll() called',
  'updateView() called',
] as const;

export type RenderLogEventName = (typeof RENDER_LOG_EVENT_NAMES)[number];
